import { useEffect } from 'react'

import { DSContainer, DSDivider } from '@vr/ds-react'
import { useSearchParams } from 'react-router-dom'

import GeneralView from './general'
import { Label, InfoText } from './styled'
import { GeneralProvider } from '@/contexts/general.context'
import useLocalStorage from '@/hooks/use-local-storage'

export const Home = () => {
  const [, setUser] = useLocalStorage('user', {})
  const [searchParams] = useSearchParams()
  const userName = searchParams.get('userName')
  const userId = searchParams.get('userId')

  useEffect(() => {
    setUser({ userId, userName })
  }, [userId, userName])

  return (
    <DSContainer fluid css={{ marginTop: '40px' }}>
      <Label as='h1'>Painel de Contratos</Label>
      <InfoText>
        Acompanhe o status dos contratos e reprocesse quando necessário
      </InfoText>
      <DSDivider css={{ marginBottom: '$sm16' }} />

      <GeneralProvider>
        <GeneralView />
      </GeneralProvider>
    </DSContainer>
  )
}
